module.exports = __webpack_public_path__ + "img/phone.d932b336.png";